export default "__VITE_ASSET__7f3c98db__"